module.exports = __webpack_public_path__ + "img/register-1-registration-form.7ecbfac4.png";